import {useEffect, useState} from "react";

import {PlaybackStatus, Player, YoutubeEvent} from "./YoutubePlayerManager";

const useIsPlaying = (player: Player | undefined): boolean => {
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (!player) {
            return;
        }

        let handle = -1;
        const setPlayingThrottled = (p: boolean) => {
            clearTimeout(handle);
            if (p) {
                setIsPlaying(true);
            } else {
                /**
                 * Seeking the video for some reason pauses the player for a millisecond
                 */
                handle = window.setTimeout(() => {
                    setIsPlaying(p);
                }, 150);
            }
        };

        const onUpdate = (state: PlaybackStatus) => {
            switch (state) {
                case PlaybackStatus.Playing:
                    setPlayingThrottled(true);
                    break;
                case PlaybackStatus.Paused:
                case PlaybackStatus.Ended:
                case PlaybackStatus.Unstarted:
                case PlaybackStatus.VideoCued:
                    setPlayingThrottled(false);
                    break;
                case PlaybackStatus.Buffering:
                    // Clear the pause timeout handle when video goes into buffering state
                    clearTimeout(handle);
                    break;
            }
        };

        const onStateChange = (event: YoutubeEvent<PlaybackStatus>) => {
            onUpdate(event.data);
        };

        onUpdate(player.getPlayerState());
        player.addEventListener('onStateChange', onStateChange);

        return () => {
            clearTimeout(handle);
            player.removeEventListener('onStateChange', onStateChange);
        };
    });


    return isPlaying;
};

export default useIsPlaying;
